import { AppState, createAppSlice } from 'slices/appSlice';
import { createPracticeSlice, PracticeState } from 'slices/practiceSlice';
import { createStageSlice, StageState } from 'slices/stageSlice';
import { createTestSlice, TestState } from 'slices/testSlice';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface StoreState extends AppState, TestState, StageState, PracticeState {}

const enableDevtools = import.meta.env.VITE_ENABLE_DEVTOOLS === 'true';
const useStore = create<StoreState>()(
  enableDevtools
    ? devtools(
        (set, get, store) => ({
          ...createAppSlice(set, get, store),
          ...createTestSlice(set, get, store),
          ...createStageSlice(set, get, store),
          ...createPracticeSlice(set, get, store),
        }),
        { name: 'SwiftPal', store: 'SwiftPal' },
      )
    : (set, get, store) => ({
        ...createAppSlice(set, get, store),
        ...createTestSlice(set, get, store),
        ...createStageSlice(set, get, store),
        ...createPracticeSlice(set, get, store),
      }),
);

export default useStore;
